import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Sparkles, TrendingUp, Heart } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
      <Helmet>
        <title>Icon Search & AI Editor – Find and edit app icons</title>
        <meta name="description" content="Search App Store icons, edit with AI, and download SVG/PNG. Start searching popular app icons worldwide." />
      </Helmet>
      {/* 英雄区域 */}
      <div className="relative overflow-hidden">
        <div className="w-full md:w-3/5 mx-auto px-0 min-h-[80vh] flex items-center justify-center">
          <div className="text-center">
            <div className="flex items-center justify-center mb-8">
              <Sparkles className="w-12 h-12 text-purple-600 mr-4" />
              <h1 className="text-4xl md:text-6xl font-bold text-gray-900">
              App Icon Generate&nbsp;
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
                  With AI
                </span>
              </h1>
            </div>
            
            <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Search for popular app icons worldwide, intelligently edit and optimize them using AI technology.
            Supports multi-region search across China, US, Japan, and Korea, with one-click download in multiple formats.
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-14">
              <div className="flex items-center text-gray-600">
                <Search className="w-5 h-5 mr-2 text-purple-600" />
                <span>Smart Search</span>
              </div>
              <div className="flex items-center text-gray-600">
                <Sparkles className="w-5 h-5 mr-2 text-purple-600" />
                <span>AI Editor</span>
              </div>
              <div className="flex items-center text-gray-600">
                <TrendingUp className="w-5 h-5 mr-2 text-purple-600" />
                <span>Multi-Format Download</span>
              </div>
            </div>

            <Link
              to="/search"
              className="inline-flex items-center px-8 py-4 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-lg font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <Search className="w-5 h-5 mr-3" />
              Start Searching Icons
            </Link>
          </div>
        </div>

        {/* 装饰性背景元素 */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-20 h-20 bg-purple-200 rounded-full opacity-20 animate-pulse"></div>
          <div className="absolute top-40 right-20 w-16 h-16 bg-blue-200 rounded-full opacity-20 animate-pulse delay-1000"></div>
          <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-indigo-200 rounded-full opacity-20 animate-pulse delay-500"></div>
          <div className="absolute bottom-40 right-1/3 w-24 h-24 bg-purple-200 rounded-full opacity-20 animate-pulse delay-1500"></div>
        </div>
      </div>

      

      {/* 底部Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <Sparkles className="w-6 h-6 text-purple-400" />
                <span className="text-xl font-bold">App Icon Generate</span>
              </div>
              <p className="text-gray-400 text-sm">
              A professional icon search and AI editing platform, offering comprehensive icon processing solutions.
              </p>
            </div>
            <div className="md:text-right">
              <div className="flex md:justify-end gap-6 text-sm flex-nowrap whitespace-nowrap">
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms of Service</Link>
                <a href="mailto:support@appicongenerator.club" className="text-gray-300 hover:text-white transition-colors">Contact Us: support@appicongenerator.club</a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy;2024 Icon Search AI Editing Platform. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
